import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';

interface CatalogBatchRemoveModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CatalogBatchRemoveModal = ({ open, onClose, onConfirm }: CatalogBatchRemoveModalProps) => {
  const { translate } = useTranslation();

  return (
    <Modal
      isOpen={open}
      size="standard"
      header={{ title: translate(LangEnum.CATALOGS_BULK_DELETE_MODAL_TITLE) }}
      onClose={onClose}
      footer={{
        primaryAction: {
          label: translate(LangEnum.CATALOGS_BULK_MENU_DELETE),
          onClick: onConfirm,
        },
        secondaryAction: {
          label: translate(LangEnum.GLOBAL_CANCEL_LABEL),
          onClick: onClose,
        },
      }}
    >
      <Typography variant="body1" color="text.secondary">
        {translate(LangEnum.CATALOGS_BULK_DELETE_MODAL_DESCRIPTION)}
      </Typography>
    </Modal>
  );
};

export default CatalogBatchRemoveModal;
